import React from "react";
import { CreateUpdateLinkFormProps } from "../../../../HOC/withCreateUpdateLinkForm";
import styles from "./CreateUpdateNewLinkFormView.module.scss";
import NodeSelectorPresenter from "../../../Node/NodeSelector/NodeSelectorPresenter";
import Button from "../../../../../../common/components/atom/Button/Button";

export default function CreateUpdateNewLinkFormView({
  formDataValue,
  setFormDataValue,
  errorMessage,
  handleSubmit,
  isErrorStatuts,
  lableSubmitButton,
  isLoading,
}: CreateUpdateLinkFormProps) {
  return (
    <div className={styles["container-form"]}>
        { errorMessage && <p className={styles["container-form__message-error"]}>{errorMessage}</p> }

      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--name"],
        ].join(" ")}
      >
        <NodeSelectorPresenter
          valueNode={formDataValue?.node1}
          setValue={(node) => {
            setFormDataValue({ ...formDataValue, node1: node });
          }}
          type={"POLE"}
          isError={isErrorStatuts?.isErrorNode1ID}
          label="Noeud 1"
          variant="dark"
          
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--name"],
        ].join(" ")}
      >
        <NodeSelectorPresenter
          valueNode={formDataValue?.node2}
          setValue={(node) => {
            setFormDataValue({ ...formDataValue, node2: node });
          }}
          type={"POLE"}
          isError={isErrorStatuts?.isErrorNode2ID}
          label="Noeud 2"
          variant="dark"
        />
      </div>
      <Button
        onClick={() => {
          handleSubmit && handleSubmit();
        }}
        variant={"dark-parimary"}
        isLoading={isLoading}
      >
        {lableSubmitButton}
      </Button>
    </div>
  );
}
